import React from 'react'
import PropTypes from 'prop-types'

let QuizQuestion = ({ title, answerText }) => (
  <li className='quiz-results__questions fr-view'>
    <span dangerouslySetInnerHTML={{ __html: title }} />
    <div className='quiz-results__choices'>
      <div className='quiz-results__choice quiz-results__choice--answer'>
        <span dangerouslySetInnerHTML={{ __html: answerText }} />
      </div>
    </div>
  </li>
)

QuizQuestion.propTypes = {
  title: PropTypes.string.isRequired,
  answerText: PropTypes.string.isRequired,
}
QuizQuestion = React.memo(QuizQuestion)
QuizQuestion.displayName = 'QuizQuestion'

export default QuizQuestion
